// extracted by mini-css-extract-plugin
module.exports = {"component":"sL7E8","form":"_2HaoM","formContent":"_2ElbE","header":"_3jNV5","subHeader":"_28vNG","submit":"_2BT2I","closeIcon":"L-8ov"};